import { Avatar, Divider, Link, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { format } from 'date-fns';
import { EstateNote } from 'queries';

import { nameToInitials } from 'utils/user';

interface Props {
  // eslint-disable-next-line @typescript-eslint/ban-types
  deleteNoteClickCallback?: Function;
  notes?: Pick<EstateNote, 'note' | 'id' | 'type' | 'updatedAt'>[];
  showDeleteLink: boolean;
  title: string | JSX.Element;
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 10,
  },
  title: {
    padding: theme.spacing(0, 1.5),
    paddingBottom: 5,
  },
  note: {
    padding: theme.spacing(0, 1.5),
    paddingTop: 7,
    paddingBottom: 7,
    '& p, h1, h2, h3': {
      marginTop: 7,
      marginBottom: 7,
    },
  },
  avatarWrapper: {
    display: 'inline',
    float: 'left',
  },
  avatar: {
    background: '#2274A5',
    marginRight: '8px',
    fontSize: '.9rem',
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  secondaryInfo: {
    color: '#434E59',
    opacity: '0.6',
  },
  link: {
    cursor: 'pointer',
  },
}));

export default function PublishedEstateNotes({
  deleteNoteClickCallback,
  notes,
  showDeleteLink,
  title,
}: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.title}>{title}</div>
      <Divider />
      {// eslint-disable-next-line @typescript-eslint/no-explicit-any
      notes?.map((estateNote: any) => {
        const noteDate = estateNote.publishDate ?? estateNote.updatedAt;
        const date: string = format(Date.parse(noteDate.toString()), 'LLL d y');
        const time: string = format(Date.parse(noteDate.toString()), 'h:mmaaa');
        return (
          <>
            <div className={classes.note}>
              <div className={classes.avatarWrapper}>
                <Avatar
                  className={classes.avatar}
                  title={estateNote.user.firstName + ' ' + estateNote.user.lastName}
                >
                  {nameToInitials(estateNote.user.firstName, estateNote.user.lastName)}
                </Avatar>
              </div>
              <span className={classes.secondaryInfo}>
                {estateNote.user.firstName} {estateNote.user.lastName}
              </span>
              <div dangerouslySetInnerHTML={{ __html: estateNote.note! }}></div>
              <Typography variant="caption" className={classes.secondaryInfo}>
                {estateNote.estate.estateName} - {date} {time}{' '}
                {showDeleteLink && (
                  <Link
                    className={classes.link}
                    onClick={() => deleteNoteClickCallback && deleteNoteClickCallback(estateNote)}
                  >
                    delete
                  </Link>
                )}
              </Typography>
            </div>
            <Divider />
          </>
        );
      })}
      {notes?.length === 0 && <div className={classes.note}>no notes</div>}
    </div>
  );
}
